import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";
export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "dashboards",
        object: "dashboard",
        header: [
            { text: "Titulo", value: "title" },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions,
        show_dashboard({ commit, state }, filters) {
            return new Promise((resolve, reject) => {
              commit("request");
              axios
                .get(config.api_url + "show_dashboard", { params: filters })
                .then((response) => {
                    commit("success");
                    resolve(response.data);
                })
                .catch((err) => {
                  commit("auth_error");
                  reject(err);
                });
            });
        },
        getApiExport({ commit, state }, filters) {

            return new Promise((resolve, reject) => {
              commit("request");
              axios
                .get(config.api_url + "show_dashboard", {
                  params: { ...filters, format: "xlsx" },
                })
                .then((response) => {
                  commit("success");

                  const a = document.createElement('a');
                  a.style.display = 'none';
                  a.href = response.data;
                  a.download = response.headers.filename;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  resolve(response.data);
                })
                .catch((err) => {
                  commit("error");
                  reject(err);
                });
            });
          },
    },
    getters: {
        ...genericStore.getters
    }
};
